module.exports = __webpack_public_path__ + "img/tema-1-1.223722d3.png";